export function mixin(Hop) {
    Hop.nativeTrigger = (target, eventType) => {
        const event = document.createEvent('HTMLEvents');
        event.initEvent(eventType, true, false);
        target.dispatchEvent(event);
    };
}
